import { useCallback } from 'react'

import { useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { STUDIO_PATH, buildGalleryImagePath } from 'Pods/ThreeDStudio/constants'
import useRequireLogin from 'Pods/ThreeDStudio/Hooks/useRequireLogin'
import { openFullImageEditor } from 'Pods/ThreeDStudio/Store/actions/ui'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

// Opens an image in the full image editor, like the library's Edit image: at its shareable
// edit URL, where ImageDeepLink opens the editor. `buildPath` picks that URL: the gallery's
// /ai-image-generator/images/:slug?edit=true by default, or /ai-image/:slug?edit=true from that
// page. An image without a slug opens in place on the Image Generator route, the only other
// route that renders the editor, flagging the navigation so the editor survives it. No runId:
// it may be another user's run, so the editor's Delete must stay disabled.
function useImageEdit({ buildPath = buildGalleryImagePath } = EMPTY_OBJECT) {
  const navigate = useNavigate()
  const requireLogin = useRequireLogin('login')

  return useCallback((image) => {
    if (!image.assetId || !requireLogin()) return

    if (image.slug) {
      navigate(buildPath(image.slug, { edit: true }))
      return
    }

    openFullImageEditor({ image: { id: image.assetId, url: image.src, alt: image.title } })
    navigate(STUDIO_PATH.IMAGE_GENERATOR, { state: { keepImageEditor: true } })
  }, [buildPath, navigate, requireLogin])
}

export default useImageEdit
